"use client";

import { ArrowRight, BookOpen, ListChecks, Search } from "lucide-react";
import { Link } from "@/components/common/Link";
const GOLF_TOOLS = [{
  id: "course-finder",
  title: "Course Finder",
  description: "Search and filter courses by destination, playing level, handicap, budget and travel style.",
  buttonLabel: "Search Courses",
  link: "/course-finder/",
  imageSrc: "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/coursefinder-1.png",
  icon: Search
}, {
  id: "course-intelligence",
  title: "Course Intelligence",
  description: "Understand the differences before you book. Compare fees, reviews, conditions, access and playability.",
  buttonLabel: "Explore Insights",
  link: "/course-intelligence/",
  imageSrc: "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/courseintelligence-1.png",
  icon: ListChecks
}, {
  id: "golf-passport",
  title: "Golf Passport",
  description: "Save favourite courses, build shortlists, follow destinations and prepare for future member benefits.",
  buttonLabel: "Create Passport",
  link: "/#home-golf-passport",
  imageSrc: "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/golfpassport-1.png",
  icon: BookOpen
}];
export default function HomeGolfTools() {
  return <section id="home-golf-tools" data-home-section="golf-tools" aria-label="TeeListClub golf planning tools" className={["w-full bg-[#F7F3E9]", "px-5 pt-20 pb-12", "md:px-8 md:pt-24 md:pb-14", "lg:px-12 lg:pt-24 lg:pb-16"].join(" ")} style={{
    fontFamily: '"Raleway", Arial, sans-serif'
  }}>
      <div className="mx-auto w-full max-w-[1480px]">
        {/* Editorial heading */}
        <div className={["mb-12 grid grid-cols-1", "gap-7", "lg:mb-14", "lg:grid-cols-[minmax(0,1.35fr)_minmax(300px,0.65fr)]", "lg:items-end", "lg:gap-16"].join(" ")}>
          <div>
            <p className="uppercase tracking-[0.2em] text-[#B79A5F] !text-xs !font-extrabold"><span className="!text-xs">Plan Smarter. Play Better.</span></p>

            <h2 className={["mt-4 max-w-[800px]", "text-[40px] font-medium", "leading-[1.04]", "tracking-[-0.035em]", "text-[#073F31]", "sm:text-[48px]", "lg:text-[56px]"].join(" ")} style={{
            fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif'
          }}>
              Choose the right tools for better golf trips.
            </h2>
          </div>

          <p className={["max-w-[520px]", "text-[15px] font-medium", "leading-[1.7]", "text-[#596B63]", "lg:justify-self-end", "lg:pb-1", "lg:text-[16px]"].join(" ")}>
            TeeListClub brings together the most useful tools for golfers
            travelling across Asia. Search, compare and organise better golf
            experiences — all in one place.
          </p>
        </div>

        {/* Three tools */}
        <div className="grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
        {GOLF_TOOLS.map(tool => {
          const Icon = tool.icon;
          return <article key={tool.id} className={["group relative flex min-h-[500px]", "flex-col overflow-hidden", "rounded-[16px]", "border border-[#D8C69B]/42", "bg-[#073F31]", "shadow-[0_14px_34px_rgba(7,63,49,0.14)]", "transition-all duration-300", "hover:-translate-y-[4px]", "hover:shadow-[0_22px_46px_rgba(7,63,49,0.20)]", "lg:min-h-[530px]"].join(" ")}>
      {/* Card image */}
      <img src={tool.imageSrc} alt="" aria-hidden="true" loading="lazy" decoding="async" className={["absolute inset-0 h-full w-full", "object-cover", "transition-transform duration-700", "group-hover:scale-[1.04]"].join(" ")} />

      {/* Readability gradient */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
              background: "linear-gradient(180deg, rgba(3,39,31,0.02) 12%, rgba(3,39,31,0.16) 38%, rgba(3,39,31,0.82) 64%, rgba(3,39,31,0.99) 100%)"
            }} />

      {/* Card content */}
      <div className={["relative z-10 flex h-full flex-1 flex-col", "px-6 pb-6 pt-[210px]", "lg:px-7 lg:pb-7 lg:pt-[235px]"].join(" ")}>
        <div className={["flex size-[54px]", "items-center justify-center", "rounded-[11px]", "border border-[#BFFF00]/45", "bg-[#073F31]/72", "text-[#BFFF00]", "backdrop-blur-md"].join(" ")}>
          <Icon className="size-[25px]" strokeWidth={1.55} aria-hidden="true" />
        </div>

        <h3 className={["mt-6", "text-[29px] font-medium", "leading-[1.08]", "tracking-[-0.025em]", "text-[#FFFDF7]", "lg:text-[31px]"].join(" ")} style={{
                fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif'
              }}>
          {tool.title}
        </h3>

        <div className="mt-3 h-px w-9 bg-[#D8BD67]" />

        <p className={["mt-4 max-w-[370px]", "text-[14px] font-medium", "leading-[1.62]", "text-[#FFFDF7]/84"].join(" ")}>
          {tool.description}
        </p>

        <a href={tool.link} aria-label={`${tool.buttonLabel}: ${tool.title}`} className={["group/button mt-auto flex", "h-[54px] w-full", "items-center justify-between", "rounded-[8px]", "bg-[#BFFF00]", "px-5", "text-[11px] font-bold uppercase", "tracking-[0.07em]", "leading-none", "text-[#073F31]", "no-underline", "transition-all duration-300", "hover:bg-[#CCFF38]"].join(" ")}>
          <span>{tool.buttonLabel}</span>

          <ArrowRight className="size-[17px] transition-transform duration-300 group-hover/button:translate-x-1" strokeWidth={1.8} aria-hidden="true" />
        </a>
      </div>
    </article>;
        })}
        </div>
      </div>
    </section>;
}